// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds6253vGGznPL_PU7aGZ{display:grid;grid-template-rows:1fr max-content;overflow:auto}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/search/pages/profile/ui/SectionMessages/ui/MessagesList/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kCAAA,CACA,aAAA","sourcesContent":[".wrap {\n  display: grid;\n  grid-template-rows: 1fr max-content;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ds6253vGGznPL_PU7aGZ`
};
export default ___CSS_LOADER_EXPORT___;
